module.exports = __webpack_public_path__ + "img/Multi-source Indicator Comparison.cfcd312e.png";